export default {
  FETCHING_NETSUITE_ASSETS_ME:
    'netSuiteAssetManager/FETCHING_NETSUITE_ASSETS_ME',
  FETCHING_NETSUITE_ASSETS_ME_SUCCESS:
    'netSuiteAssetManager/FETCHING_NETSUITE_ASSETS_ME_SUCCESS',
  FETCHING_NETSUITE_ASSETS_ME_ERROR:
    'netSuiteAssetManager/FETCHING_NETSUITE_ASSETS_ME_ERROR',
  FETCHING_NETSUITE_ASSETS: 'netSuiteAssetManager/FETCHING_NETSUITE_ASSETS',
  FETCHING_NETSUITE_ASSETS_SUCCESS:
    'netSuiteAssetManager/FETCHING_NETSUITE_ASSETS_SUCCESS',
  FETCHING_NETSUITE_ASSETS_ERROR:
    'netSuiteAssetManager/FETCHING_NETSUITE_ASSETS_ERROR',
  ASSIGNING_NETSUITE_ASSET: 'netSuiteAssetManager/ASSIGNING_NETSUITE_ASSET',
  ASSIGNING_NETSUITE_ASSET_SUCCESS:
    'netSuiteAssetManager/ASSIGNING_NETSUITE_ASSET_SUCCESS',
  ASSIGNING_NETSUITE_ASSET_ERROR:
    'netSuiteAssetManager/ASSIGNING_NETSUITE_ASSET_ERROR',
}
